// ABOUTME: Notification event catalog for the settings drawer — operator-level, transmormer, and legacy per-integration events.
import { NotificationErrorType } from '../../../types/enums';

export interface EventDescriptor {
  /** Stored key in a subscription's notificationSettings map. */
  key: NotificationErrorType;
  /** Human label shown next to the toggle. */
  label: string;
}

// Fires when an admin disables one of the operator's integrations. A single
// operator-level event, not tied to transmormer vs legacy.
export const INTEGRATION_DISABLED_EVENT: EventDescriptor = {
  key: NotificationErrorType.IntegrationDisabled,
  label: 'Integration disabled',
};

// Sync failures across the operator's Transmormer paths (one shared key).
export const TRANSMORMER_EVENT: EventDescriptor = {
  key: NotificationErrorType.TransmormerSyncFailures,
  label: 'Sync failures',
};

// Legacy sync events keyed by the integration identifier used in polling/config
// docs. Only integrations that have legacy notification keys appear here;
// everything else is covered by the Transmormer event.
export const LEGACY_INTEGRATION_EVENTS: Record<string, EventDescriptor[]> = {
  AMOS: [
    { key: NotificationErrorType.AmosDefects, label: 'Defects' },
    { key: NotificationErrorType.AmosFlights, label: 'Flights' },
    { key: NotificationErrorType.AmosUplifts, label: 'Uplifts' },
    { key: NotificationErrorType.AmosUsers, label: 'Users' },
    { key: NotificationErrorType.AmosWorkpackages, label: 'Workpackages' },
  ],
  LEON: [{ key: NotificationErrorType.LeonFlights, label: 'Flights' }],
  CAMP: [
    { key: NotificationErrorType.CampActuals, label: 'Actuals' },
    { key: NotificationErrorType.CampDefects, label: 'Defects' },
  ],
};

/** Integration identifiers that carry legacy notification events. */
export const LEGACY_INTEGRATIONS = Object.keys(LEGACY_INTEGRATION_EVENTS);
